var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7, _linearGradient8, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Brain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "mXwFPBc4ZN6VLnzsFQjIUa",
    x1: 23.101,
    x2: 37.146,
    y1: 250.719,
    y2: 213.215,
    gradientTransform: "matrix(1 0 0 -1 0 254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c41f40"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mXwFPBc4ZN6VLnzsFQjIUa)",
    d: "M24,9.75C24,7.127,26.127,5,28.75,5c2.413,0,4.384,1.806,4.688,4.136 C37.169,9.814,40,13.073,40,17c0,0.279-0.015,0.554-0.042,0.826C41.831,19.643,43,22.183,43,25c0,2.821-1.173,5.365-3.052,7.183 C39.98,32.451,40,32.723,40,33c0,3.665-2.819,6.668-6.406,6.97C32.829,41.751,31.061,43,29,43c-2.761,0-5-2.239-5-5 C24,37.617,24,10.438,24,9.75z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "mXwFPBc4ZN6VLnzsFQjIUb",
    x1: 11.05,
    x2: 23.315,
    y1: 247.244,
    y2: 208.066,
    gradientTransform: "matrix(1 0 0 -1 0 254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa1a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f24472"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mXwFPBc4ZN6VLnzsFQjIUb)",
    d: "M24,9.75C24,7.127,21.873,5,19.25,5c-2.413,0-4.384,1.806-4.688,4.136 C10.831,9.814,8,13.073,8,17c0,0.279,0.015,0.554,0.042,0.826C6.169,19.643,5,22.183,5,25c0,2.821,1.173,5.365,3.052,7.183 C8.02,32.451,8,32.723,8,33c0,3.665,2.819,6.668,6.406,6.97C15.171,41.751,16.939,43,19,43c2.761,0,5-2.239,5-5 C24,37.617,24,10.438,24,9.75z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "mXwFPBc4ZN6VLnzsFQjIUc",
    x1: 12.403,
    x2: 27.793,
    y1: 246.763,
    y2: 208.213,
    gradientTransform: "matrix(1 0 0 -1 0 254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c41f40"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mXwFPBc4ZN6VLnzsFQjIUc)",
    d: "M24,33c0,1.595-1.035,2.589-2.208,2.897C21.335,36.017,21,36.4,21,36.872l0,0 c0,0.667,0.637,1.133,1.283,0.968C24.446,37.287,26,35.359,26,33H24z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "mXwFPBc4ZN6VLnzsFQjIUd",
    x1: 14.806,
    x2: 29.064,
    y1: 246.969,
    y2: 211.253,
    gradientTransform: "matrix(1 0 0 -1 0 254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c41f40"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mXwFPBc4ZN6VLnzsFQjIUd)",
    d: "M17.123,19h0.002c0.471,0,0.856-0.338,0.969-0.795c0.28-1.134,1.154-1.851,2.12-2.103 c0.453-0.119,0.786-0.5,0.786-0.968v-0.258c0-0.471-0.338-0.856-0.795-0.969c-1.134-0.28-1.851-1.154-2.103-2.12 C17.983,11.333,17.602,11,17.134,11h-0.011c-0.655,0-1.129,0.622-0.967,1.257c0.285,1.121,0.946,2.076,1.839,2.743 c-0.894,0.666-1.554,1.621-1.839,2.743C15.994,18.378,16.468,19,17.123,19z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "mXwFPBc4ZN6VLnzsFQjIUe",
    x1: 8.959,
    x2: 23.711,
    y1: 244.265,
    y2: 207.313,
    gradientTransform: "matrix(1 0 0 -1 0 254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c41f40"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mXwFPBc4ZN6VLnzsFQjIUe)",
    d: "M18.912,24L18.912,24c-0.493,0-0.895,0.367-0.985,0.852c-0.279,1.508-1.307,2.096-2.24,2.138 c-1.059-0.505-2.256-0.829-3.586-0.944C11.513,25.996,11,26.453,11,27.043l0,0c0,0.507,0.38,0.952,0.886,0.989 c2.766,0.204,4.722,1.394,5.832,3.547c0.227,0.439,0.762,0.621,1.223,0.444l0,0c0.562-0.216,0.806-0.881,0.523-1.413 c-0.453-0.851-1.023-1.589-1.693-2.214c1.03-0.602,1.865-1.667,2.136-3.254C20.009,24.543,19.519,24,18.912,24z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "mXwFPBc4ZN6VLnzsFQjIUf",
    x1: 24.895,
    x2: 40.765,
    y1: 252.084,
    y2: 217.603,
    gradientTransform: "matrix(1 0 0 -1 0 254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa1a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f24472"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mXwFPBc4ZN6VLnzsFQjIUf)",
    d: "M33.313,18.99c-0.932-0.042-1.96-0.63-2.24-2.138C30.984,16.367,30.582,16,30.088,16l0,0 c-0.607,0-1.098,0.543-0.996,1.141c0.271,1.586,1.106,2.651,2.135,3.255c-0.669,0.625-1.239,1.363-1.692,2.215 c-0.283,0.531-0.039,1.196,0.523,1.413l0,0c0.461,0.178,0.996-0.004,1.223-0.444c1.111-2.153,3.067-3.344,5.833-3.548 C37.62,19.994,38,19.55,38,19.043l0,0c0-0.59-0.513-1.047-1.101-0.996C35.569,18.161,34.372,18.485,33.313,18.99z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "mXwFPBc4ZN6VLnzsFQjIUg",
    x1: 15.463,
    x2: 31.673,
    y1: 248.239,
    y2: 213.02,
    gradientTransform: "matrix(1 0 0 -1 0 254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa1a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f24472"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mXwFPBc4ZN6VLnzsFQjIUg)",
    d: "M24,23h-2c0,2.359,1.554,4.287,3.717,4.84C26.363,28.006,27,27.539,27,26.872l0,0 c0-0.472-0.335-0.855-0.792-0.975C25.035,25.589,24,24.595,24,23z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "mXwFPBc4ZN6VLnzsFQjIUh",
    x1: 18.207,
    x2: 34.182,
    y1: 248.007,
    y2: 213.297,
    gradientTransform: "matrix(1 0 0 -1 0 254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa1a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f24472"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mXwFPBc4ZN6VLnzsFQjIUh)",
    d: "M31.871,30L31.871,30c-0.471,0-0.854,0.334-0.973,0.79c-0.253,0.964-0.969,1.836-2.102,2.116 C28.338,33.019,28,33.404,28,33.876v0.258c0,0.469,0.333,0.85,0.786,0.968c0.966,0.252,1.839,0.968,2.12,2.102 C31.019,37.662,31.405,38,31.876,38l0,0c0.656,0,1.13-0.623,0.968-1.258c-0.285-1.121-0.946-2.076-1.839-2.742 c0.892-0.665,1.551-1.618,1.838-2.736C33.006,30.626,32.529,30,31.871,30z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd000",
    d: "M43.707,4.293c-0.391-0.391-1.024-0.391-1.414,0c-0.195,0.195-1.805,1.805-2,2 c-0.391,0.391-0.391,1.024,0,1.414c0.391,0.391,1.024,0.391,1.414,0c0.195-0.195,1.805-1.805,2-2 C44.098,5.317,44.098,4.683,43.707,4.293z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd000",
    d: "M36.924,0.77c-0.51-0.211-1.095,0.031-1.307,0.541c-0.106,0.255-0.977,2.358-1.082,2.613 c-0.211,0.51,0.031,1.095,0.541,1.307c0.51,0.211,1.095-0.031,1.307-0.541c0.106-0.255,0.977-2.358,1.082-2.613 C37.676,1.566,37.434,0.981,36.924,0.77z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd000",
    d: "M46.816,11.076c-0.211-0.51-0.796-0.753-1.307-0.541c-0.255,0.106-2.358,0.977-2.613,1.082 c-0.51,0.211-0.753,0.796-0.541,1.307c0.211,0.51,0.796,0.753,1.307,0.541c0.255-0.106,2.358-0.977,2.613-1.082 C46.785,12.171,47.028,11.586,46.816,11.076z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd000",
    d: "M4.293,4.293c-0.391,0.391-0.391,1.024,0,1.414c0.195,0.195,1.805,1.805,2,2 c0.391,0.391,1.024,0.391,1.414,0c0.391-0.391,0.391-1.024,0-1.414c-0.195-0.195-1.805-1.805-2-2 C5.317,3.902,4.683,3.902,4.293,4.293z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd000",
    d: "M0.77,11.076c-0.211,0.51,0.031,1.095,0.541,1.307c0.255,0.106,2.358,0.977,2.613,1.082 c0.51,0.211,1.095-0.031,1.307-0.541c0.211-0.51-0.031-1.095-0.541-1.307c-0.255-0.106-2.358-0.977-2.613-1.082 C1.566,10.324,0.981,10.566,0.77,11.076z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd000",
    d: "M11.076,1.184c-0.51,0.211-0.753,0.796-0.541,1.307c0.106,0.255,0.977,2.358,1.082,2.613 c0.211,0.51,0.796,0.753,1.307,0.541c0.51-0.211,0.753-0.796,0.541-1.307c-0.106-0.255-0.977-2.358-1.082-2.613 C12.171,1.215,11.586,0.972,11.076,1.184z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd000",
    d: "M4.293,43.707c0.391,0.391,1.024,0.391,1.414,0c0.195-0.195,1.805-1.805,2-2 c0.391-0.391,0.391-1.024,0-1.414c-0.391-0.391-1.024-0.391-1.414,0c-0.195,0.195-1.805,1.805-2,2 C3.902,42.683,3.902,43.317,4.293,43.707z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd000",
    d: "M11.076,47.23c0.51,0.211,1.095-0.031,1.307-0.541c0.106-0.255,0.977-2.358,1.082-2.613 c0.211-0.51-0.031-1.095-0.541-1.307c-0.51-0.211-1.095,0.031-1.307,0.541c-0.106,0.255-0.977,2.358-1.082,2.613 C10.324,46.434,10.566,47.019,11.076,47.23z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd000",
    d: "M1.184,36.924c0.211,0.51,0.796,0.753,1.307,0.541c0.255-0.106,2.358-0.977,2.613-1.082 c0.51-0.211,0.753-0.796,0.541-1.307c-0.211-0.51-0.796-0.753-1.307-0.541c-0.255,0.106-2.358,0.977-2.613,1.082 C1.215,35.829,0.972,36.414,1.184,36.924z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd000",
    d: "M43.707,43.707c0.391-0.391,0.391-1.024,0-1.414c-0.195-0.195-1.805-1.805-2-2 c-0.391-0.391-1.024-0.391-1.414,0c-0.391,0.391-0.391,1.024,0,1.414c0.195,0.195,1.805,1.805,2,2 C42.683,44.098,43.317,44.098,43.707,43.707z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd000",
    d: "M47.23,36.924c0.211-0.51-0.031-1.095-0.541-1.307c-0.255-0.106-2.358-0.977-2.613-1.082 c-0.51-0.211-1.095,0.031-1.307,0.541c-0.211,0.51,0.031,1.095,0.541,1.307c0.255,0.106,2.358,0.977,2.613,1.082 C46.434,37.676,47.019,37.434,47.23,36.924z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd000",
    d: "M36.924,46.816c0.51-0.211,0.753-0.796,0.541-1.307c-0.106-0.255-0.977-2.358-1.082-2.613 c-0.211-0.51-0.796-0.753-1.307-0.541c-0.51,0.211-0.753,0.796-0.541,1.307c0.106,0.255,0.977,2.358,1.082,2.613 C35.829,46.785,36.414,47.028,36.924,46.816z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Brain);
export default __webpack_public_path__ + "static/media/icons8-brain.afcf6c932d346299faf6ba29f6ae513c.svg";
export { ForwardRef as ReactComponent };